import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../../../api/quarkusApi';

export function usePrescriptionTemplate() {
  const navigate = useNavigate();

  const [templateMode, setTemplateMode] = useState(null);
  const [clinicTemplate, setClinicTemplate] = useState(null);
  const [dentistTemplates, setDentistTemplates] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTemplateConfig = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/clinic/', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => {
        const mode = returnFromApi.data?.prescriptionTemplateMode ?? null;
        const clinicId = returnFromApi.data?.id ?? null;
        setTemplateMode(mode);

        const endpoint =
          mode === 'CLINIC'
            ? `/clinic-prescription-template/from-clinic/${clinicId}`
            : '/clinic-prescription-template/from-dentists';

        return quarkusApi
          .get(endpoint, { headers: { Authorization: sessionStorage.getItem('token') } })
          .then((res) => {
            if (mode === 'CLINIC') {
              setClinicTemplate(res.data);
            } else {
              setDentistTemplates(res.data);
            }
          });
      })
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchTemplateConfig();
  }, [fetchTemplateConfig]);

  return { templateMode, clinicTemplate, dentistTemplates, isLoading, error };
}
